interface TreatmentEmptyProps extends React.ComponentPropsWithoutRef<"div"> {
  title: string
}

// When a record is empty
const TreatmentEmpty = ({ title }: TreatmentEmptyProps) => {
  return (
    <div className="animate-fade-in-bottom grid h-full content-center items-center justify-center gap-4 p-3 text-center">
      <div className="grid gap-1">
        <h2 className="text-on-surface text-xl font-bold">{title}</h2>
      </div>
    </div>
  )
}

export { TreatmentEmpty }
